"use client"

import { WeightTilde } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `WeightTildeIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const WeightTildeIcon = component(Icon)({ as: WeightTilde })
